import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const marketsAdapter = getAdapter();

const marketsSlice = createSlice({
  name: 'markets',
  initialState: marketsAdapter.getInitialState(),
  reducers: {
    setMarkets: (state, { payload: { markets } }) => {
      marketsAdapter.setAll(state, markets);
    },
  },
});

const selectors = marketsAdapter.getSelectors(({ markets }) => markets);

export const getMarketsIncludingDeleted = (state) => selectors.selectAll(state);

export const getMarkets = (state) => getMarketsIncludingDeleted(state)
  .filter(({ isDeleted }) => !isDeleted);

export const {
  setMarkets,
} = marketsSlice.actions;

export default marketsSlice.reducer;
